'use client'

import { useAppRouter } from '@/shared/lib/router'

import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult
} from '@tanstack/react-query'

export type AppSession = {
  user?: Record<string, unknown>
  expires?: string
  [key: string]: unknown
}

export const fetchSession = async (): Promise<AppSession | null> => {
  const res = await fetch('/api/auth/session')
  const session = await res.json()
  return Object.keys(session).length > 0 ? session : null
}

type UseSessionOptions = {
  required?: boolean
  redirectTo?: string
  queryOptions?: Omit<UseQueryOptions<AppSession | null>, 'queryKey' | 'queryFn'>
}

export function useSession({
  required,
  redirectTo = '/api/auth/signin?error=SessionExpired',
  queryOptions = {}
}: UseSessionOptions = {}): UseQueryResult<AppSession | null, Error> {
  const router = useAppRouter()

  return useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      const session = await fetchSession()
      if (!session && required) router.push(redirectTo)
      return session
    },
    ...queryOptions
  })
}
